module.exports = __webpack_public_path__ + "1ea2550d82d9515bed7127cc1762e4b3.svg";